module.exports = __webpack_public_path__ + "static/media/blog-2.46593e52.jpg";